import { UPDATE_SUPPLIER, UPDATE_SUPPLIER_LIST, UPDATE_SUPPLIER_MAP, ACTION_LOGOUT_INITIATED } from '../actions/types';

const initialState = {
	suppliers_map: {},
	suppliers_list: [],
	supplier: '',
	sellerPortalConfig: {}
};

export default function (state = initialState, action) {
	switch (action.type) {
		case UPDATE_SUPPLIER_MAP:
			return {
				...state,
				suppliers_map: action.payload,
			};

		case UPDATE_SUPPLIER_LIST:
			return {
				...state,
				suppliers_list: action.payload,
			};

		case UPDATE_SUPPLIER:
			return {
				...state,
				supplier: action.payload,
				sellerPortalConfig: state.suppliers_map?.[action.payload]?.seller_portal_config || {}
			};

		case ACTION_LOGOUT_INITIATED:
			return initialState;
	
		default:
			return state;
	}
}
